export default __webpack_public_path__ + "static/media/cake_rainbow.da455d2d.jpg";